//首页相关

//子导航
$(function () {
  const origin = window.location.origin;
  const content_url = '/';
  let hoverNavId = '';
  const title = $('.nav-item.active').attr('title');
  const id = $('.nav-item.active').attr('data-id');
  if (title === '首页' && Number(id) === 10) {
    window._czc &&
      window._czc.push([
        '_trackPageview',
        content_url,
        `${origin}${content_url}`,
      ]);
  }

  $('.home-header-banner-wrap .nav-wrap .nav-item').hover(
    function () {
      hoverNavId = $(this).attr('data-id');
      toggerSubNav();
    },
    function () {
      hoverNavId = '';
      toggerSubNav();
    }
  );

  $('.sub-nav-group-wrap').hover(
    function () {
      clearTimeout(timeout);
    },
    function () {
      hoverNavId = '';
      toggerSubNav();
    }
  );

  // $(".production-services-block module-list").first()

  let timeout = null;
  const toggerSubNav = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      hideSubNav();
      if (hoverNavId) {
        const $links = $(
          `.sub-nav-group-item[data-id="${hoverNavId}"] a.sub-nav-item`
        );
        console.log($links, 'links====================');
        if ($links.length > 0) {
          $(
            `.sub-nav-group-wrap .sub-nav-group-item[data-id="${hoverNavId}"]`
          ).removeClass('hide');
        }
      }
    }, 100);
  };
  const hideSubNav = () => {
    $('.home-header-banner-wrap')
      .find('.sub-nav-group-wrap .sub-nav-group-item')
      .addClass('hide');
  };
});

//banner图片轮播
$(function () {
  const $imgs = $('.home-header-banner-wrap .img-swiper-item');
  if ($imgs.length > 1) {
    const $pagination = $('<div class="pagination-wrap"></div>');
    for (let i = 0; i < $imgs.length; i++) {
      $pagination.append(
        '<div class="pagination-item"><i class="white-box"></i></div>'
      );
    }
    $('.home-header-banner-wrap .img-swiper-list').after($pagination);
  }
  //
  const $paginations = $(
    '.home-header-banner-wrap .pagination-wrap .pagination-item'
  );
  //
  let activeIndex = 0;
  const activeSync = () => {
    if (!$imgs.get(activeIndex)) {
      activeIndex = 0;
    }
    $imgs.removeClass('active').eq(activeIndex).addClass('active');
    $paginations.removeClass('active').eq(activeIndex).addClass('active');
  };
  setTimeout(activeSync, 100);
  $paginations.on('click', function () {
    activeIndex = $paginations.index($(this));
    activeSync();
    restartInterval();
  });
  let interval = null;
  const restartInterval = () => {
    clearInterval(interval);
    interval = setInterval(() => {
      activeIndex++;
      activeSync();
    }, 5000);
  };
  restartInterval();
});

// 农业前沿----------------------------------------
require('./farm');

// 数字乡村----------------------------------------
// 图片倒影canvas
$(function () {
  const $imgs = $('.szxc-block .module-item .img-item');
  $imgs.each(function () {
    const $t = $(this);
    const $img = $t.find('img');
    const cImg = new Image();
    cImg.onload = () => {
      const canvas = $t.find('canvas').get(0);
      canvas.width = cImg.width;
      canvas.height = cImg.height;
      const ctx = canvas.getContext('2d');
      const grd = ctx.createLinearGradient(0, 0, 0, $img.height());
      ctx.drawImage(cImg, 0, 0, $img.width(), $img.height());
      grd.addColorStop(0, 'rgba(255,255,255,0.7)');
      grd.addColorStop(0.3, 'rgba(255,255,255,0.7)');
      grd.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = grd;
      ctx.fillRect(0, 0, $img.width(), $img.height());
    };
    setTimeout(() => {
      cImg.src = $img.attr('src');
    }, 100);
  });
});
// 图片轮播
$(function () {
  const init = ($imgs) => {
    let leftIndex = 0;
    const classSync = () => {
      //重置每一张图片的class
      if (!$imgs.get(leftIndex)) {
        leftIndex = 0;
      }
      let middleIndex = leftIndex + 1;
      if (!$imgs.get(middleIndex)) {
        middleIndex = 0;
      }
      let rightIndex = middleIndex + 1;
      if (!$imgs.get(rightIndex)) {
        rightIndex = 0;
      }
      $imgs.removeClass('left middle right');
      $imgs.eq(leftIndex).removeClass('middle right').addClass('left');
      $imgs.eq(middleIndex).removeClass('left right').addClass('middle');
      $imgs.eq(rightIndex).removeClass('left middle').addClass('right');
    };
    const showNext = () => {
      //显示下一张图片
      leftIndex++;
      classSync();
    };
    classSync();
    //----------------------------------------------------------------------
    const showPrev = () => {
      //显示上一张图片
      leftIndex--;
      if (!$imgs.get(leftIndex)) {
        leftIndex = $imgs.length - 1;
      }
      classSync();
    };
    //--------------------------------------------------------------------------
    const $imgList = $imgs.parents('.img-list');
    const bindMouseMove = require('../../utils/bindMouseMove');
    bindMouseMove($imgList);
    let lastMoveTime = 0;
    $imgList.on('mouseLeftMove', () => {
      if ($.now() - lastMoveTime > 500) {
        showNext();
        lastMoveTime = $.now();
        restartInterval();
      }
    });
    $imgList.on('mouseRightMove', () => {
      if ($.now() - lastMoveTime > 500) {
        showPrev();
        lastMoveTime = $.now();
        restartInterval();
      }
    });
    // //点击某个图片 把它放到最中间
    // $imgs.on('click', function () {
    //   const middleIndex = $imgs.index($(this));
    //   console.log(middleIndex);
    //   leftIndex = middleIndex - 1;
    //   classSync();
    // });
    //
    const restartInterval = (() => {
      let interval = null;
      return () => {
        clearInterval(interval);
        interval = setInterval(showNext, 50000000);
      };
    })();
    restartInterval();
  };
  //数字乡村建设 图片轮播
  init($('.szxc-block .module-index-1 .img-item'));
  //村里办 图片轮播
  init($('.szxc-block .module-index-2 .img-item'));
});
//-------物联网AIOT
require('./aiot');
//-------最新动态
require('./news');
//-----------------------
// 行业应用
$(() => {
  let activeTitle = null; //标记当前选中的选项
  let activeSubTitle = null; //标记当前选中的子选项
  let activeTitle1 = null; //标记当前选中的选项
  let activeSubTitle1 = null; //标记当前选中的子选项
  // 设置每个 选项/子选项 的选中状态
  const activeSync = () => {
    //
    // $(".industry-apply-block .switch-item")
    //   .removeClass("active")
    //   .filter(`[data-title="${activeTitle}"]`)
    //   .addClass("active");
    //
    $('.industry-apply-block .sub-switch-item')
      .removeClass('active')
      .filter(
        `.switch-item[data-title="${activeTitle}"] .sub-switch-item[data-title="${activeSubTitle}"]`
      )
      .addClass('active');

    // 获取第二项应用标题
    $('.industry-apply-block .sub-switch-item1')
      .removeClass('active')
      .filter(
        `.switch-item[data-title="${activeTitle1}"] .sub-switch-item1[data-title="${activeSubTitle1}"]`
      )
      .addClass('active');
    //
    $('.industry-apply-block .module-list .module-item .child-list .child-item')
      .removeClass('active')
      .filter(
        `.module-item[data-title="${activeTitle}"] .child-item[data-title="${activeSubTitle}"]`
      )
      .addClass('active');

    // 获取第二项标题对应的内容
    $(
      '.industry-apply-block .module-list .module-item .child-list .child-item1'
    )
      .removeClass('active')
      .filter(
        `.module-item[data-title="${activeTitle1}"] .child-item1[data-title="${activeSubTitle1}"]`
      )
      .addClass('active');

    //
    $(window).trigger('scroll');
  };
  //
  $('.industry-apply-block')
    .on('click', '.sub-switch-item', function (event) {
      //子选项被点击后 选中该子选项和它的父级选项
      event.stopPropagation();
      const $t = $(this);
      activeSubTitle = $t.attr('data-title');
      activeTitle = $t.parents('.switch-item').attr('data-title');
      activeSync();
    })
    .on('click', '.sub-switch-item1', function (event) {
      //子选项被点击后 选中该子选项和它的父级选项
      event.stopPropagation();
      const $t = $(this);
      activeSubTitle1 = $t.attr('data-title');
      activeTitle1 = $t.parents('.switch-item').attr('data-title');
      activeSync();
    })

    .on('click', '.switch-item', function () {
      //选项被点击后 选中该选项和它的第一个子选项
      const $t = $(this);
      // activeTitle = $t.attr("data-title");
      // activeTitle1 = $t.attr("data-title");
      // activeSubTitle = $t.find(".sub-switch-item").first().attr("data-title");
      // activeSubTitle1 = $t.find(".sub-switch-item1").first().attr("data-title");
      activeSync();
    })
    .find('.switch-item .sub-switch-item')
    .first()
    .trigger('click'); //默认选中第一个选项
  // 默认选中第二项数组的第一项
  $('.industry-apply-block').find('.sub-switch-item1').first().trigger('click'); //默认选中第一个选项
});

// 合作共赢
$(() => {
  $('.cooperate-block .group-switch')
    .on('click', '.switch-item', function () {
      //
      $('.cooperate-block .group-switch .switch-item').removeClass('active');
      $('.cooperate-block .group-list .group-item').removeClass('active');
      //
      const code = $(this).addClass('active').attr('data-code');
      $(
        `.cooperate-block .group-list .group-item[data-code="${code}"]`
      ).addClass('active');
      $(window).trigger('scroll');
    })
    .find('.switch-item')
    .first()
    .trigger('click');
});

// 底部
$(function () {
  let url = window.location.pathname;
  if (url == '/login.html') {
    $('.link-col-wrap').css('display', 'none');
    $('.twoLogin').css('display', 'block');
    $('.site-map-wrapMain').css({ display: 'flex', 'align-items': 'center' });
    $('.site-map-wrap').css('margin-top', 0);
    $('.text-box').css('width', '40%');
    $('.infoText').css('width', '850px');
  }
});
